import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";
import { cn } from "@nt/ui/cn";
import { inputVariants } from "@nt/ui/field";

// The design system's control (@nt/ui/field): the 3:1 `border-input` edge,
// a forest focus edge with a soft forest ring, danger when `aria-invalid`. Control
// height follows the density tier — 36px in the console, 44px on touch.
function Input({
  className,
  type,
  trailingAction,
  ...props
}: React.ComponentProps<"input"> & {
  /**
   * Leaves room at the end for a button laid over the box (a search's clear
   * ×), and hides the browser's own search cancel glyph that would sit beside it.
   */
  trailingAction?: boolean;
}) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        inputVariants({ kind: "input" }),
        trailingAction && "pr-8 [&::-webkit-search-cancel-button]:hidden",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
